let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eQXoP")).then(() => parcelRequire('6Vk9P'));